import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { DeviceFingerprintService } from '@app/shared/services/helpers/device-fingerprint.service';
import { AuthService } from '@app/shared/auth/auth.service';

@Component({
  standalone: true,
  imports: [CommonModule, MatIconModule, ReactiveFormsModule],
  selector: 'app-device-access-request',
  templateUrl: './device-access-request.component.html',
  styleUrls: ['./device-access-request.component.scss']
})
export class DeviceAccessRequestComponent implements OnInit {
  requestForm: FormGroup;
  isSubmitting = false;
  submitError: string | null = null;
  submitSuccess = false;
  private deviceToken: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private deviceFingerprintService: DeviceFingerprintService,
    private authService: AuthService
  ) {
    this.requestForm = this.fb.group({
      label: ['', [Validators.required, Validators.maxLength(255)]]
    });
  }

  ngOnInit() {
    // Get token from query params
    this.route.queryParams.subscribe(params => {
      this.deviceToken = params['deviceToken'] || null;
    });
  }


  onSubmit() {
    if (this.requestForm.invalid || this.isSubmitting) {
      return;
    }
    if (this.requestForm.get('label')?.value?.trim() === '') {
      this.submitError = 'Device label is required.';
      return;
    }

    this.isSubmitting = true;
    this.submitError = null;
    this.submitSuccess = false;

    const deviceFingerprint = this.deviceFingerprintService.getDeviceFingerprintHeader();
    if (!deviceFingerprint) {
      this.submitError = 'Device fingerprint not found. Please refresh the page.';
      this.isSubmitting = false;
      return;
    }

    if (!this.deviceToken) {
      this.submitError = 'Device access token not found. Please try logging in again.';
      this.isSubmitting = false;
      return;
    }

    const deviceName = this.requestForm.get('label')?.value?.trim() || '';
    this.authService.updateDeviceLabelFromAccessRequest(deviceFingerprint, this.deviceToken, deviceName).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        this.submitSuccess = true;

        // Show success message and redirect after a delay
        setTimeout(() => {
          this.router.navigate(['/auth/login']);
        }, 5000);
      },
      error: (error) => {
        this.isSubmitting = false;
        this.submitError = error.error?.error || error.error?.message || 'Failed to submit device access request. Please try again.';
      }
    });
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }
}

